// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileHint_wrapper__fVxmW","title":"MobileHint_title__Rus81","subtitle":"MobileHint_subtitle__Zb4M7"};